var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { loc, createButton, Collection } from "../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import oktaUnderscore from "../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import AuthenticatorEnrollOptions from "../components/AuthenticatorEnrollOptions.js";
import AuthenticatorVerifyOptions from "../components/AuthenticatorVerifyOptions.js";
import { getAuthenticatorDataForEnroll, getAuthenticatorDataForVerification } from "../utils/AuthenticatorUtil.js";
import { FORMS, AUTHENTICATOR_KEY } from "../../ion/RemediationConstants.js";
import IDP from "../../../util/IDP.js";
import AdminScopeList from "../../../v1/views/admin-consent/ScopeList.js";
import EnduserScopeList from "../../../v1/views/consent/ScopeList.js";
import CaptchaView from "../views/captcha/CaptchaView.js";
const isTextOverflowing = (text, maxWidth) => {
  const elem = document.createElement("div");
  elem.style.position = "absolute";
  elem.style.left = "-9999px";
  elem.style.whiteSpace = "nowrap";
  elem.innerHTML = text;
  document.body.appendChild(elem);
  const result = elem.clientWidth;
  document.body.removeChild(elem);
  return result > maxWidth;
};
const createAuthenticatorEnrollSelectView = (opt) => {
  const optionItems = (opt.options || []).map((opt2) => {
    return Object.assign({}, opt2, getAuthenticatorDataForEnroll(opt2));
  });
  return {
    View: AuthenticatorEnrollOptions,
    options: {
      name: opt.name,
      collection: new Collection(optionItems)
    }
  };
};
const createAuthenticatorVerifySelectView = (opt) => {
  let optionItems = opt.options || [];
  const authSet = /* @__PURE__ */ new Set();
  optionItems = optionItems.filter((opt2) => {
    let isDuplicate;
    if (opt2.authenticatorKey === AUTHENTICATOR_KEY.WEBAUTHN) {
      isDuplicate = authSet.has(opt2.authenticatorKey);
      authSet.add(opt2.authenticatorKey);
    } else if (opt2.authenticatorKey === AUTHENTICATOR_KEY.CUSTOM_APP) {
      var _opt$value, _opt$value2;
      isDuplicate = authSet.has(opt2 === null || opt2 === void 0 ? void 0 : (_opt$value = opt2.value) === null || _opt$value === void 0 ? void 0 : _opt$value.id);
      authSet.add(opt2 === null || opt2 === void 0 ? void 0 : (_opt$value2 = opt2.value) === null || _opt$value2 === void 0 ? void 0 : _opt$value2.id);
    }
    return !isDuplicate;
  });
  optionItems = optionItems.map((opt2) => {
    return Object.assign({}, opt2, getAuthenticatorDataForVerification(opt2));
  });
  return {
    View: AuthenticatorVerifyOptions,
    options: {
      name: opt.name,
      collection: new Collection(optionItems)
    }
  };
};
const createAdminScopesView = () => {
  return {
    View: AdminScopeList
  };
};
const createEnduserScopesView = () => {
  return {
    View: EnduserScopeList
  };
};
const createCaptchaView = (opt) => {
  return {
    View: CaptchaView,
    options: {
      name: opt.name
    }
  };
};
const inputCreationStrategy = {
  authenticatorEnrollSelect: createAuthenticatorEnrollSelectView,
  authenticatorVerifySelect: createAuthenticatorVerifySelectView,
  ["admin-consent"]: createAdminScopesView,
  ["consent"]: createEnduserScopesView,
  ["captcha"]: createCaptchaView
};
const create = function(uiSchemaObj) {
  const strategyFn = inputCreationStrategy[uiSchemaObj.type] || oktaUnderscore.identity;
  return strategyFn(uiSchemaObj);
};
const createPIVButton = (settings, appState) => {
  const pivIdp = appState.get("remediations").filter((idp) => idp.name === FORMS.PIV_IDP);
  if (pivIdp.length < 1) {
    return [];
  }
  const pivConfig = settings.get("piv");
  const className = pivConfig.className || "";
  return [{
    attributes: {
      "data-se": "piv-card-button"
    },
    className: className + " piv-button",
    title: pivConfig.text || loc("piv.cac.card", "login"),
    click: (e) => {
      e.preventDefault();
      appState.trigger("switchForm", FORMS.PIV_IDP);
    }
  }];
};
const createIdpButtons = ({
  settings,
  appState
}) => {
  const MAX_IDP_BUTTON_WIDTH = 186;
  const redirectIdpRemediations = appState.get("remediations").filter((idp) => idp.name === FORMS.REDIRECT_IDP);
  if (!Array.isArray(redirectIdpRemediations)) {
    return [];
  }
  const pivButton = createPIVButton(settings, appState);
  const idpButtons = redirectIdpRemediations.map((idpObject) => {
    var _idpObject$type;
    let type = (_idpObject$type = idpObject.type) === null || _idpObject$type === void 0 ? void 0 : _idpObject$type.toLowerCase();
    let displayName;
    if (!oktaUnderscore.contains(IDP.SUPPORTED_SOCIAL_IDPS, type)) {
      var _idpObject$idp;
      type = "general-idp";
      displayName = loc("customauth.sign.in.with.label", "login", [(_idpObject$idp = idpObject.idp) === null || _idpObject$idp === void 0 ? void 0 : _idpObject$idp.name]);
    } else {
      displayName = loc(`socialauth.${type}.label`, "login");
    }
    const classNames = ["social-auth-button", `social-auth-${type}-button`];
    if (type === "general-idp") {
      classNames.push("no-translate");
    }
    if (idpObject.idp.className) {
      classNames.push(idpObject.idp.className);
    }
    const button = {
      attributes: {
        "data-se": `social-auth-${type}-button`
      },
      className: classNames.join(" "),
      title: displayName,
      href: idpObject.href
    };
    if (isTextOverflowing(displayName, MAX_IDP_BUTTON_WIDTH)) {
      button.attributes.title = displayName;
    }
    return button;
  });
  return [...pivButton, ...idpButtons];
};
const createCustomButtons = (settings) => {
  const customButtons = settings.get("customButtons");
  return customButtons.map((customButton) => {
    const button = {
      attributes: {
        "data-se": customButton.dataAttr
      },
      className: customButton.className + " default-custom-button",
      title: customButton.title || loc(customButton.i18nKey, "login"),
      click: customButton.click
    };
    return button;
  });
};
const addCustomButton = (customButtonSettings) => {
  return createButton(__spreadProps(__spreadValues({}, customButtonSettings), {
    className: `${customButtonSettings.className} default-custom-button button-primary`
  }));
};
export { addCustomButton, create, createCustomButtons, createIdpButtons, isTextOverflowing };
